// Always use relative API path - works in all environments
export const API = '/api';
